module.exports = __webpack_public_path__ + "img/130-50M-CMS 4_3.970a43da.png";